import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "nonzero",
  d: "M10.75 3.04a.75.75 0 0 1 1.188-.609l5.5 3.96a.75.75 0 0 1 .08 1.152L12.847 12l4.67 4.457a.75.75 0 0 1 .008 1.08l-.081.067-5.5 4.04a.75.75 0 0 1-1.194-.604V14l-4.232 4.043a.75.75 0 0 1-.978.05l-.083-.075a.75.75 0 0 1 .025-1.06L10.676 12 5.482 7.043a.75.75 0 0 1-.095-.975l.07-.086a.75.75 0 0 1 1.06-.025l4.233 4.04zm1.5 10.462v6.056l3.585-2.634zm0-8.998v5.993l3.579-3.416z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }